import { ReduxStore } from 'store/types';

function getAllIsLoading(state: ReduxStore): boolean {
  return state.user.getAll.config.isLoading;
}

export default getAllIsLoading;
